import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { CssBaseline } from '@material-ui/core';
import "./index.css";
import { ThemeProvider } from "@material-ui/core/styles";
import theme from "./theme";

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App />
      <CssBaseline />
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
